export default __webpack_public_path__ + "static/1427-f4efc5c4032d60537c3d8c4a1e75fb3b.gif";